export default {"src":"/_next/static/media/3.1-h.88051d32.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};